<template>
  <div class="container mt-3">
    <h5 class="mb-3">发帖</h5>
    <b-form-group label="标题" label-for="title"><b-form-input id="title" v-model="title" maxlength="45"></b-form-input></b-form-group>
    <div class="mb-2 d-flex align-items-center">
      <b-button size="sm" class="mr-2" @click="fmt('bold')">B</b-button>
      <b-button size="sm" class="mr-2" @click="fmt('italic')">I</b-button>
      <b-button size="sm" class="mr-2" @click="fmt('justifyLeft')">H</b-button>
      <b-button size="sm" class="mr-2" @click="fmt('h1')">H1</b-button>
      <b-button size="sm" class="mr-2" @click="fmt('h2')">H2</b-button>
      <b-button size="sm" class="mr-2" @click="fmt('link')">Link</b-button>
      <b-button size="sm" class="mr-2" @click="fmt('code')">Code</b-button>
      <b-button size="sm" class="mr-2" @click="fmt('ul')">• List</b-button>
      <b-button size="sm" class="mr-2" @click="fmt('ol')">1. List</b-button>
      <b-form-select v-model="fontSize" :options="fontSizes" size="sm" class="w-auto mr-2" @change="applyFontSize"></b-form-select>
      <input type="color" v-model="fontColor" class="mr-2" @change="applyColor" />
      <b-button size="sm" class="mr-2" @click="insertEmoji('😊')">😊</b-button>
      <b-button size="sm" class="mr-2" @click="undo">↶</b-button>
      <b-button size="sm" class="mr-2" @click="redo">↷</b-button>
      <b-button size="sm" class="mr-2" @click="triggerImage">🖼️</b-button>
      <input ref="imgFile" type="file" accept="image/*" class="d-none" @change="onImageFileChange" />
    </div>
    <div ref="editor" class="form-control post-editor" contenteditable="true" @input="onEdit" @compositionstart="onCompStart" @compositionend="onCompEnd"></div>
    <b-button variant="primary" size="sm" @click="submit" :disabled="submitting">发布</b-button>
    <b-alert :show="msg!==''" variant="info" class="mt-2">{{ msg }}</b-alert>
  </div>
</template>

<script>
import { request_zzquant } from 'network/request.js'
export default {
  data(){ return { title:'', content:'', file:null, images:[], submitting:false, msg:'', isComposing:false, fontSize:'16px', fontSizes:['14px','16px','18px','20px'], fontColor:'#333333', ro:null } },
  mounted(){ this.initResizeObserver(); this.attachImgResizeObserver() },
  methods:{
    upload(){ if(!this.file) return; const form=new FormData(); form.append('file',this.file); request_zzquant({ url:'/user/post/image/upload', method:'POST', data:form, headers:{ 'Content-Type':'multipart/form-data' } }).then(res=>{ const url=res.data&&res.data.data?res.data.data.url:null; if(url){ this.images.push(url); this.insertHtml(`<span class="post-img-wrap"><img src="${url}" /></span>`); this.file=null; } }) },
    triggerImage(){ if(this.$refs.imgFile){ this.$refs.imgFile.click() } },
    onImageFileChange(e){ const f=e.target.files&&e.target.files[0]?e.target.files[0]:null; if(!f) return; this.file=f; this.upload() },
    submit(){
      const html=(this.content||'').replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi,'')
      const title=(this.title||'').trim()
      if(!title){ this.msg='请输入标题'; return }
      if(!html.trim()){ this.msg='请输入内容'; return }
      try{
        const tk = localStorage.getItem('token')
        if(!tk){
          const current = this.$router.currentRoute && this.$router.currentRoute.fullPath ? this.$router.currentRoute.fullPath : '/'
          this.$router.push({ path: '/login', query: { redirect: current } })
          this.msg = '发帖需要登录与权限'
          return
        }
        const raw = localStorage.getItem('user_info')
        if(raw){
          try{
            const u = JSON.parse(raw)
            const r = u && u.roles
            const arr = Array.isArray(r) ? r : String(r||'').split(',').map(s=>s.trim()).filter(Boolean)
            if(arr.length && !arr.includes('post')){ this.msg = '没有发帖权限'; return }
          }catch(e){ /* ignore */ }
        }
      }catch(e){ /* ignore */ }
      this.submitting=true
      request_zzquant({ url:'/user/post/create', method:'POST', data:{ title, content: html, images:this.images } })
        .then(res=>{
          const id = res && res.data && res.data.data ? res.data.data.id : null
          this.msg='发布成功'
          this.submitting=false
          if(id){ this.$router.push('/community/post/'+id) } else { this.title=''; this.content=''; if(this.$refs.editor){ this.$refs.editor.innerHTML=''; } this.images=[] }
        })
        .catch(err=>{
          const msg = (err && err.message) ? String(err.message) : ''
          const hints = ['无权限','未登录','验证失败','Unauthorized','需要登录','未授权']
          const status401 = !!(err && err.status === 401)
          const unauthorized = !!(err && err.__unauthorized)
          const byMsg = hints.some(h => msg.indexOf(h) !== -1)
          this.msg = (status401 || unauthorized || byMsg) ? '没有发帖权限或未登录' : '发布失败，请稍后重试'
          this.submitting=false
        })
    },
    full(u){ if(!u) return ''; if(u.startsWith('http')) return u; return 'https://api.zizizaizai.com'+u },
    onEdit(e){ if(this.isComposing) return; this.content = e.target.innerHTML },
    onCompStart(){ this.isComposing = true },
    onCompEnd(){ this.isComposing = false; if(this.$refs.editor){ this.content = this.$refs.editor.innerHTML } },
    focusEditor(){ if(this.$refs.editor){ this.$refs.editor.focus() } },
    insertHtml(html){ this.focusEditor(); const sel=window.getSelection(); if(sel && sel.rangeCount>0){ const r=sel.getRangeAt(0); r.deleteContents(); const el=document.createElement('div'); el.innerHTML=html; const frag=document.createDocumentFragment(); let node; while((node=el.firstChild)){ frag.appendChild(node) } r.insertNode(frag); sel.collapseToEnd(); this.onEdit({ target: this.$refs.editor }); this.$nextTick(()=>{ this.attachImgResizeObserver() }) } else { this.content += html; this.$nextTick(()=>{ this.attachImgResizeObserver() }) } },
    fmt(type){ this.focusEditor(); if(type==='bold'){ document.execCommand('bold', false, null); this.onEdit({ target: this.$refs.editor }); return } if(type==='italic'){ document.execCommand('italic', false, null); this.onEdit({ target: this.$refs.editor }); return } if(type==='justifyLeft'){ document.execCommand('justifyLeft', false, null); this.onEdit({ target: this.$refs.editor }); return } if(type==='h1'){ document.execCommand('formatBlock', false, 'h1'); this.onEdit({ target: this.$refs.editor }); return } if(type==='h2'){ document.execCommand('formatBlock', false, 'h2'); this.onEdit({ target: this.$refs.editor }); return } if(type==='link'){ document.execCommand('createLink', false, 'https://'); this.onEdit({ target: this.$refs.editor }); return } if(type==='code'){ this.insertHtml('<code>代码</code>'); return } if(type==='ul'){ this.insertHtml('<ul><li>列表项</li></ul>'); return } if(type==='ol'){ document.execCommand('insertOrderedList', false, null); this.onEdit({ target: this.$refs.editor }); return } this.onEdit({ target: this.$refs.editor }) },
    applyFontSize(){ const size=this.fontSize||'16px'; const sel=window.getSelection(); if(sel && sel.rangeCount>0){ const r=sel.getRangeAt(0); const span=document.createElement('span'); span.style.fontSize=size; r.surroundContents(span); this.onEdit({ target: this.$refs.editor }) } },
    applyColor(){ const color=this.fontColor||'#333333'; const sel=window.getSelection(); if(sel && sel.rangeCount>0){ const r=sel.getRangeAt(0); const span=document.createElement('span'); span.style.color=color; r.surroundContents(span); this.onEdit({ target: this.$refs.editor }) } },
    insertEmoji(e){ this.insertHtml(e) },
    undo(){ document.execCommand('undo', false, null); this.onEdit({ target: this.$refs.editor }) },
    redo(){ document.execCommand('redo', false, null); this.onEdit({ target: this.$refs.editor }) },
    initResizeObserver(){
      if(typeof ResizeObserver === 'undefined') return
      this.ro = new ResizeObserver(entries => {
        entries.forEach(entry => {
          const el = entry.target
          const rect = entry.contentRect
          el.style.width = Math.round(rect.width) + 'px'
          // height 由等比缩放图片决定，不强制设置
          this.onEdit({ target: this.$refs.editor })
        })
      })
    },
    attachImgResizeObserver(){
      if(!this.ro || !this.$refs.editor) return
      const wraps = this.$refs.editor.querySelectorAll('.post-img-wrap')
      wraps.forEach(el => { try{ this.ro.observe(el) }catch(e){ console.warn('observe image resize failed', e) } })
    }
  }
}
</script>

<style>
.form-control img{ max-width:100%; height:auto; }
.post-content img{ max-width:100%; height:auto; }
.post-editor{ min-height:200px; height:auto; overflow:auto; }
.post-img-wrap{ display:inline-block; width:180px; max-width:100%; resize:both; overflow:auto; }
.post-img-wrap img{ width:100%; height:auto; }
</style>
